import app from 'flarum/forum/app';
import Badge from 'flarum/common/components/Badge';
import highlight from 'flarum/common/helpers/highlight';
import MentionableModel from './MentionableModel';
export default class TagMention extends MentionableModel {
  type() {
    return 'tag';
  }
  initialResults() {
    return Array.from(app.store.all('tags'));
  }

  /**
   * Generates the mention syntax for a tag mention.
   *
   * ~tagSlug
   *
   * @example <caption>Tag mention</caption>
   * // ~general
   * forTag(tag) // Tag display name is 'Tag', tag ID is 5
   */
  replacement(tag) {
    return this.format.format(tag.slug());
  }
  matches(model, typed) {
    if (!typed) return false;
    const names = [model.name().toLowerCase()];
    return names.some(name => name.toLowerCase().substr(0, typed.length) === typed);
  }
  maxStoreMatchedResults() {
    return null;
  }
  async search(typed) {
    return await app.store.find('tags', {
      filter: {
        q: typed
      },
      page: {
        limit: 5
      }
    });
  }
  suggestion(model, typed) {
    let tagName = model.name();
    if (typed) {
      tagName = highlight(tagName, typed);
    }
    return m('[', null, m(Badge, {
      className: "Avatar",
      icon: model.icon(),
      color: model.color(),
      type: "tag"
    }), m("span", {
      className: "username"
    }, tagName));
  }
  enabled() {
    return 'flarum-tags' in flarum.extensions;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/TagMention', TagMention);